import { createAction } from '@reduxjs/toolkit'

/**
 * 新しいチャットの最初の指示でセッションを作った。仮の ID（domain/pendingId.ts）で持っていた会話と開いているチャットを、
 * 作ったセッションに移す。会話と開いているチャットの slice がそれぞれ受ける
 */
export const sessionIdAssigned = createAction<{ pendingSessionId: string; agentSessionId: string }>(
  'agentWidget/sessionIdAssigned',
)
